import { observable, action, toJS } from 'mobx';
import { Api } from 'services/Api';

class ScopeOfWorkTemplateStore {
  @observable scopeOfWorkTemplates = {
    isLoading: false,
    isError: false,
    objects: [],
    meta: {}
  };

  @action
  loadScopeOfWorkTemplates() {
    this.scopeOfWorkTemplates.isLoading = true;

    let promise = Api.get(`/scope_of_works/`);

    return promise
      .then((response) => {
        this.scopeOfWorkTemplates.isLoading = false;
        this.scopeOfWorkTemplates.isError = false;
        this.scopeOfWorkTemplates.objects = response?.data?.data || []
      })
      .catch((error) => {
        this.scopeOfWorkTemplates.isLoading = false;
        this.scopeOfWorkTemplates.isError = true;
      })
  }

  // Create, update and delete leave the list's loading/error state alone (a
  // failed save isn't a failed load), reload the list when they succeed, and
  // pass failures on so the page can say what went wrong.
  @action
  createScopeOfWorkTemplate(name, description) {
    return Api.post('/scope_of_works', { name, description })
      .then((response) => {
        this.loadScopeOfWorkTemplates();
        return response;
      });
  }

  @action
  deleteScopeOfWorkTemplate(uuid) {
    return Api.delete(`/scope_of_works/${uuid}`)
      .then((response) => {
        this.loadScopeOfWorkTemplates();
        return response;
      });
  }

  @action
  updateScopeOfWorkTemplate(uuid, data) {
    return Api.put(`/scope_of_works/${uuid}`, data)
      .then((response) => {
        this.loadScopeOfWorkTemplates();
        return response;
      });
  }
}

export default ScopeOfWorkTemplateStore;